const eventEmitter = new EventTarget();

export default eventEmitter;
